/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { PageTitle } from '../../../umart_admin/layout/core';
import { Button, Col, Row } from 'react-bootstrap';
import { DashboardString } from '../../../utils/string';
import ActiveCustomersChart from './ActiveCustomersChart';
import OrderReport from './OrderReport';
import APICallService from '../../../api/apiCallService';
import { dashBoardEndPoints } from '../../../api/apiEndPoints';
import SalesReport from './SalesReport';
import Loader from '../../../Global/loader';
import DashboardReport from '../../modals/reports/dashboard-reports';
import Method from '../../../utils/methods';
import { useAuth } from '../../modules/auth';
import { useNavigate } from 'react-router-dom';
import OrderReportV2 from './OrderReportV2';
import CategoryReportChart from './CategoryReport';
const DashboardPage: FC = () => {
  const navigate = useNavigate();
  const { saveCurrentUser, currentUser }: any = useAuth();
  const [loading, setLoading] = useState(true);
  const [initData, setInitData] = useState<any>();
  const [showReportModal, setShowReportModal] = useState(false);
  useEffect(() => {
    (async () => {
      setLoading(true);
      await fetchInitData();
      setLoading(false);
    })();
  }, []);
  const fetchInitData = async () => {
    setLoading(true);
    const params = {
      needStats: true,
      needCategories: true,
      needTopCustomers: true,
      needTopProducts: true,
      needCustomersWithNoOrdersFrom15Days: true,
      needCustomersOneOrder: true,
      needCustomersWithLoginNoOrders: true,
      needCustomersRegisteredToday: true,
      needOrdersPlacedToday: true,
      needOrdersCancelledToday: true,
      needOrdersDeliveredToday: true,
      needAverageOrderValue: true,
      needAverageSKUsPerOrder: true,
      needEngagedCustomers: true,
      needOnlineAndCODOrders: true,
      needSKUsSoldToday: true,
      needOnTimeDeliveryRate: true,
      needTotalReturnedOrders: true,
      needOnTimeActualDeliveredOrderRate: true,
      needAvgTimePerDelivery: true,
      needReturnedSKUs: true,
    };
    const apiService = new APICallService(
      dashBoardEndPoints.getInitData,
      params
    );
    const response = await apiService.callAPI();
    if (response) {
      const tempResponse = { ...response };
      tempResponse.topCustomers = response?.topCustomers.slice(0, 5);
      tempResponse.topProducts = response?.topProducts.records.slice(0, 5);
      setInitData(tempResponse);
      if (!currentUser || currentUser?._id !== response?.user?._id) {
        saveCurrentUser(response?.user);
      }
    }
    setLoading(false);
  };
  const fetchCategoryReportData = async () => {
    const apiCallService = new APICallService(
      dashBoardEndPoints.categoryReport
    );
    const response = await apiCallService.callAPI();
    if (response) {
    }
  };
  return (
    <>
      {showReportModal ? (
        <DashboardReport
          show={showReportModal}
          onHide={() => setShowReportModal(false)}
        />
      ) : (
        <></>
      )}
      <Row className="align-items-center admin-dashboard">
        <Col xs={12} className="mb-5">
          <div className="admin-page-heading">
            <div>
              <h1 className="admin-page-title">U-Mart Admin Dashboard</h1>
              <p className="admin-page-description">
                Overview of customer orders, warehouse inventory, retention metrics, and sales reporting.
              </p>
            </div>
            {!loading && (
              <div className="admin-page-actions admin-dashboard-actions d-flex flex-wrap gap-2">
                <Button
                  variant="light"
                  className="btn-sm d-inline-flex align-items-center gap-2"
                  onClick={() =>
                    navigate('/supply-chain-dashboard', {
                      state: {
                        onTimeDeliveryRate: initData?.onTimeDeliveryRate || 0,
                        totalReturnedOrders: initData?.totalReturnedOrders || 0,
                        onTimeDeliveredOrderRate:
                          initData?.onTimeDeliveredOrderRate || 0,
                        avgTimePerDelivery: initData?.avgTimePerDelivery || 0,
                        returnedSKUs: initData?.returnedSKUs || {},
                      },
                    })
                  }
                >
                  <i className="bi bi-truck" aria-hidden="true" />
                  <span>Supply Chain Dashboard</span>
                </Button>
                <Button
                  variant="primary"
                  className="btn-sm d-inline-flex align-items-center gap-2"
                  onClick={() => setShowReportModal(true)}
                >
                  <i className="bi bi-download" aria-hidden="true" />
                  <span>Download Report</span>
                </Button>
              </div>
            )}
          </div>
        </Col>
        {loading ? (
          <div className="w-100 d-flex justify-content-center">
            <Loader loading={loading} />
          </div>
        ) : (
          <>
            {' '}
            <Col
              xs={12}
              className="mb-7"
            >
              <Row className="g-4 admin-metrics admin-metrics-primary">
                <Col
                  xl={3}
                  md={6}
                  sm={4}
                >
                  <div className="admin-metric admin-metric--green">
                    <div>
                      <div className="admin-metric-label">
                        {DashboardString.totalWareHouses}
                      </div>
                      <div className="admin-metric-value">
                        {initData?.stats?.totalWarehouses || 0}
                      </div>
                      <div className="admin-metric-caption">Warehouse count</div>
                    </div>
                    <div className="admin-metric-icon">
                      <i className="bi bi-building" aria-hidden="true" />
                    </div>
                  </div>
                </Col>
                <Col
                  xl={3}
                  md={6}
                  sm={4}
                >
                  <div className="admin-metric admin-metric--amber">
                    <div>
                      <div className="admin-metric-label">
                        {DashboardString.totalCustomers}
                      </div>
                      <div className="admin-metric-value">
                        {initData?.stats?.totalBuyers || 0}
                      </div>
                      <div className="admin-metric-caption">Customer accounts</div>
                    </div>
                    <div className="admin-metric-icon">
                      <i className="bi bi-people" aria-hidden="true" />
                    </div>
                  </div>
                </Col>
                <Col
                  xl={3}
                  md={6}
                  sm={4}
                >
                  <div className="admin-metric admin-metric--blue">
                    <div>
                      <div className="admin-metric-label">
                        {DashboardString.totalProduct}
                      </div>
                      <div className="admin-metric-value">
                        {initData?.stats?.totalListedProducts || 0}
                      </div>
                      <div className="admin-metric-caption">Listed products</div>
                    </div>
                    <div className="admin-metric-icon">
                      <i className="bi bi-box-seam" aria-hidden="true" />
                    </div>
                  </div>
                </Col>
                <Col
                  xl={3}
                  md={6}
                  sm={4}
                >
                  <div className="admin-metric admin-metric--violet">
                    <div>
                      <div className="admin-metric-label">
                        {DashboardString.totalOrders}
                      </div>
                      <div className="admin-metric-value">
                        {initData?.stats?.totalOrders || 0}
                      </div>
                      <div className="admin-metric-caption">All orders</div>
                    </div>
                    <div className="admin-metric-icon">
                      <i className="bi bi-cart" aria-hidden="true" />
                    </div>
                  </div>
                </Col>
              </Row>
              <Row className="g-4 mt-0 admin-metrics admin-metrics-secondary">
                <Col
                  xl={3}
                  md={6}
                  sm={4}
                >
                  <div className="admin-metric">
                    <div>
                      <div className="admin-metric-label">App Installs</div>
                      <div className="d-flex flex-wrap gap-4">
                        <div>
                          <div className="admin-metric-caption">Android</div>
                          <div className="admin-metric-value">
                            {Method.convertToMillionOrThousand(
                              initData?.stats?.totalAppInstalled &&
                                initData?.stats?.totalAppInstalled[0]
                                ? initData?.stats?.totalAppInstalled[0]
                                    ?.installedDevices || 0
                                : 0
                            )}
                          </div>
                        </div>
                        <div>
                          <div className="admin-metric-caption">iOS</div>
                          <div className="admin-metric-value">
                            {Method.convertToMillionOrThousand(
                              initData?.stats?.totalAppInstalled &&
                                initData?.stats?.totalAppInstalled[1]
                                ? initData?.stats?.totalAppInstalled[1]
                                    ?.installedDevices || 0
                                : 0
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="admin-metric-icon">
                      <i className="bi bi-phone" aria-hidden="true" />
                    </div>
                  </div>
                </Col>
                <Col
                  xl={3}
                  md={6}
                  sm={4}
                >
                  <div
                    className="admin-metric cursor-pointer"
                    onClick={() => navigate('/login-not-order-place-order')}
                    role="link"
                  >
                    <div>
                      <div className="admin-metric-label">
                        {'Login & not placed order'}
                      </div>
                      <div className="admin-metric-value">
                        {initData?.customersWithLoginNoOrders || 0}
                      </div>
                    </div>
                    <div className="admin-metric-icon">
                      <i className="bi bi-person" aria-hidden="true" />
                    </div>
                  </div>
                </Col>
                <Col
                  xl={3}
                  md={6}
                  sm={4}
                >
                  <div
                    className="admin-metric cursor-pointer"
                    onClick={() => navigate('/placed-one-order-report')}
                    role="link"
                  >
                    <div>
                      <div className="admin-metric-label">Placed one order</div>
                      <div className="admin-metric-value">
                        {initData?.customersWithOneOrder || 0}
                      </div>
                    </div>
                    <div className="admin-metric-icon">
                      <i className="bi bi-person" aria-hidden="true" />
                    </div>
                  </div>
                </Col>
                <Col
                  xl={3}
                  md={6}
                  sm={4}
                >
                  <div
                    className="admin-metric cursor-pointer"
                    onClick={() => navigate('/no-order-last-15day-report')}
                    role="link"
                  >
                    <div>
                      <div className="admin-metric-label">
                        {'No orders from last 15 days'}
                      </div>
                      <div className="admin-metric-value">
                        {initData?.customersWithNoOrdersFrom15Days || 0}
                      </div>
                    </div>
                    <div className="admin-metric-icon">
                      <i className="bi bi-person" aria-hidden="true" />
                    </div>
                  </div>
                </Col>
                {/* <Col
                  xl={3}
                  md={6}
                  sm={4}
                >
                  <div className="border-r8px bg-fff4d9 rounded py-4 px-5 d-flex justify-content-between align-items-center h-90px">
                    <div>
                      <div className="d-flex align-items-center">
                        <div className="fs-22 fw-bolder">
                          {initData?.customersRegisteredToday || 0}
                        </div>
                      </div>
                      <div className="fw-500 fs-16">
                        {'Customer registered today'}
                      </div>
                    </div>
                    <div className="bg-white  rounded-circle w-50px h-50px d-flex align-items-center justify-content-center">
                      <img src={CustomersImg} />
                    </div>
                  </div>
                </Col>
                <Col
                  xl={3}
                  md={6}
                  sm={4}
                >
                  <div className="border-r8px bg-d5d5f2 rounded py-4 px-5 d-flex justify-content-between align-items-center h-90px">
                    <div>
                      <div className="d-flex align-items-center">
                        <div className="fs-22 fw-bolder">
                          {initData?.ordersPlacedToday || 0}
                        </div>
                      </div>
                      <div className="fw-500 fs-16">{'Order placed today'}</div>
                    </div>
                    <div className="bg-white  rounded-circle w-50px h-50px d-flex align-items-center justify-content-center">
                      <img src={OrdersImg} />
                    </div>
                  </div>
                </Col>
                <Col
                  xl={3}
                  md={6}
                  sm={4}
                >
                  <div className="border-r8px bg-ade8f4 rounded py-4 px-5 d-flex justify-content-between align-items-center h-90px ">
                    <div>
                      <div className="d-flex align-items-center">
                        <div className="fs-22 fw-bolder">
                          {initData?.ordersDeliveredToday || 0}
                        </div>
                      </div>
                      <div className="fw-500 fs-16">
                        {'Order delivered today'}
                      </div>
                    </div>
                    <div className="bg-white  rounded-circle w-50px h-50px d-flex align-items-center justify-content-center">
                      <img
                        src={LoginOrder}
                        height={22}
                      />
                    </div>
                  </div>
                </Col>
                <Col
                  xl={3}
                  md={6}
                  sm={4}
                >
                  <div className="border-r8px bg-fff4d9 rounded py-4 px-5 d-flex justify-content-between align-items-center h-90px">
                    <div>
                      <div className="d-flex align-items-center">
                        <div className="fs-22 fw-bolder">
                          {initData?.ordersCancelledToday || 0}
                        </div>
                      </div>
                      <div className="fw-500 fs-16">
                        {'Order cancelled today'}
                      </div>
                    </div>
                    <div className="bg-white  rounded-circle w-50px h-50px d-flex align-items-center justify-content-center">
                      <img
                        src={StoppedOrder}
                        height={22}
                      />
                    </div>
                  </div>
                </Col> */}
                <Col
                  xl={3}
                  md={6}
                  sm={4}
                >
                  <div className="admin-metric">
                    <div>
                      <div className="admin-metric-label">
                        {'Avg order value (TSh)'}
                      </div>
                      <div className="admin-metric-value">
                        {Method.formatCurrency(
                          initData?.averageOrderValue || 0
                        )}
                      </div>
                    </div>
                    <div className="admin-metric-icon">
                      <i className="bi bi-receipt" aria-hidden="true" />
                    </div>
                  </div>
                </Col>
                <Col
                  xl={3}
                  md={6}
                  sm={4}
                >
                  <div className="admin-metric">
                    <div>
                      <div className="admin-metric-label">Avg SKUs per order</div>
                      <div className="admin-metric-value">
                        {initData?.averageSKUsPerOrder || 0}
                      </div>
                    </div>
                    <div className="admin-metric-icon">
                      <i className="bi bi-box-seam" aria-hidden="true" />
                    </div>
                  </div>
                </Col>
                <Col
                  xl={3}
                  md={6}
                  sm={4}
                >
                  <div className="admin-metric">
                    <div>
                      <div className="admin-metric-label">Engaged customers</div>
                      <div className="admin-metric-value">
                        {initData?.engagedCustomers || 0}
                      </div>
                      <div className="admin-metric-caption">Last one month</div>
                    </div>
                    <div className="admin-metric-icon">
                      <i className="bi bi-people" aria-hidden="true" />
                    </div>
                  </div>
                </Col>
                <Col
                  xl={3}
                  md={6}
                  sm={4}
                >
                  <div className="admin-metric">
                    <div>
                      <div className="admin-metric-label">Payment Breakdown</div>
                      <div className="d-flex flex-wrap gap-4">
                        <div>
                          <div className="admin-metric-caption">Online</div>
                          <div className="admin-metric-value">
                            {Method.formatCurrency(
                              initData?.onlineAndCODOrders?.Online || 0
                            )}
                          </div>
                        </div>
                        <div>
                          <div className="admin-metric-caption">Cash/Wallet</div>
                          <div className="admin-metric-value">
                            {Method.formatCurrency(
                              initData?.onlineAndCODOrders?.COD || 0
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="admin-metric-icon">
                      <i className="bi bi-receipt" aria-hidden="true" />
                    </div>
                  </div>
                </Col>
              </Row>
            </Col>
            <Col
              xs={12}
              className="mb-7"
            >
              <section className="admin-live-analytics d-flex flex-wrap align-items-center gap-4" aria-labelledby="today-analytics-title">
                <h2 id="today-analytics-title" className="fs-6 fw-bold mb-0">Today's Analytics</h2>
                <div className="admin-live-item">
                  <span>Customers registered</span>
                  <strong>{initData?.customersRegisteredToday || 0}</strong>
                </div>
                <div className="admin-live-item">
                  <span>Orders placed</span>
                  <strong>{initData?.ordersPlacedToday || 0}</strong>
                </div>
                <div className="admin-live-item">
                  <span>Orders delivered</span>
                  <strong>{initData?.ordersDeliveredToday || 0}</strong>
                </div>
                <div className="admin-live-item">
                  <span>Orders cancelled</span>
                  <strong>{initData?.ordersCancelledToday || 0}</strong>
                </div>
                <div className="admin-live-item">
                  <span>SKUs sold</span>
                  <strong>{initData?.skusSoldToday || 0}</strong>
                </div>
              </section>
            </Col>
            <Col
              xs={12}
              className="mb-7"
            >
              <SalesReport />
            </Col>
            <Col
              xs={12}
              className="mb-2"
            >
              <ActiveCustomersChart />
            </Col>
            <Col
              xs={12}
              className="mb-7"
            >
              <OrderReport
                customers={initData?.topCustomers || []}
                products={initData?.topProducts || []}
              />
            </Col>
            <Col
              xs={12}
              className="mb-7"
            >
              <OrderReportV2 />
            </Col>
            <Col
              xs={12}
              className="mb-7"
            >
              <CategoryReportChart />
            </Col>
          </>
        )}
      </Row>
    </>
  );
};
const DashboardWrapper: FC = () => {
  const intl = useIntl();
  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({ id: 'MENU.DASHBOARD' })}
      </PageTitle>
      <DashboardPage />
    </>
  );
};
export { DashboardWrapper };
